import classes from './DateSelector.module.css';
import DatePicker from 'react-datepicker';
import clsx from 'clsx';
import { MdDateRange } from 'react-icons/md';
import 'react-datepicker/dist/react-datepicker.css'; // Make sure this is included for datepicker styles

const DateSelector = ({ label, id, value, setter, onBlur = () => {}, errorText = '', ...rest }) => {
  // Get the current date for limiting the maximum selectable date
  const today = new Date();
  const startYear = 1900; // or any year you want
  const endYear = today.getFullYear();
  return (
    <div
      className={clsx(classes.wrapper, {
        [classes.error]: errorText
      })}>
      {label && (
        <label
          className={classes.label}
          htmlFor={`date-selector-${id}`}
          style={{ fontSize: '14px' }}>
          {label}
          <span className={'steric'}>*</span>
        </label>
      )}
      <div className={classes.container}>
        <DatePicker
          portalId="calendar-portal" // Add a portal ID
          selected={value}
          onChange={(date) => {
            if (typeof setter === 'function') setter(date);
          }}
          placeholderText="dd/mm/yyyy"
          // maxDate={today} // Prevents selecting current and future dates
          // minDate={today}
          {...rest}
          dateFormat="dd/MM/yyyy" // Custom format for the date
          showYearDropdown // Show year dropdown
          yearDropdownItemNumber={endYear - startYear + 1} // Number of years to display
          scrollableYearDropdown // Allows scrolling through years
        />
        <span className={classes.icon}>
          <MdDateRange size={20} color="var(--icon-color)" />
        </span>
      </div>
      {errorText && <p className="errorText">{errorText}</p>}
    </div>
  );
};

export default DateSelector;


